<div style="width: 100%;background-color:#dee8f4;padding: 10px">
  <form #loginForm="ngForm">
    <div *ngFor="let group of validFilters" style="float: left;clear:none;width:100%">
      <h4 mat-line>{{group.title}}</h4>
      <div *ngFor="let input of group.inputs" [ngSwitch]="input.type">
        <div *ngSwitchCase="'checkbox'">
          <mat-checkbox *ngFor="let value of input.values" style="margin-right: 1em;"
            [(ngModel)]="filterModel[value.name]" name="{{value.name}}" [attr.checked]="filterModel[value.name]" ngDefaultControl title="{{value.text}}"
              [style.visibility]="value.name !== 'coordinador'?'visible':'hidden'" [style.width]="value.name !== 'coordinador'?null:'10px'">
            <span *ngIf="!value.icon" [style.color]="value.name == 'destacat'?'red':''">{{value.text}}</span>
            <mat-icon *ngIf="value.icon !=''" style="vertical-align: middle;font-size: 14px; color:red" title="{{value.text}}">{{value.icon}}</mat-icon>
          </mat-checkbox>
        </div>

        <div *ngIf="input.type=='text'" style="float:left;clear:none;width:100%">
          <mat-form-field *ngFor="let value of input.values" style="float:left;clear:none" [style.width]="getWidthByType(value.type)"> 
              <input *ngIf="['text', 'value', 'date'].includes(value.type)"
                matInput
                [placeholder]="value.text"
                [attr.list]="getDatalist(value)"
                [(ngModel)]="filterText[value.name]"
                name="{{value.name}}"
                (blur)="textToModel(value)"
                style="float:left;clear:none">

              <button *ngIf="['text', 'value', 'date'].includes(value.type)" mat-icon-button matSuffix type="button"
                (click)="openFilterDialog(value)"
                style="float:right;height:0px;margin-top:-20px">
                <mat-icon>tune</mat-icon>
              </button>

              <input *ngIf="!['text', 'value', 'date'].includes(value.type)" matInput [placeholder]="value.text" style="float:left;clear:none"
              [attr.list]="getDatalist(value)" name="{{value.name}}" 
              [(ngModel)]="filterModel[value.name]"
              ngDefaultControl title="{{filterModel[value.name]}}">
           
              <mat-checkbox *ngIf="value.name == 'dataTecnic'" style="float:right;height:0px;margin-top:-20px" 
               [(ngModel)]="filterModel['coordinador']" name="coordinador"
               ngDefaultControl  title="Coordinació">
              </mat-checkbox>
          </mat-form-field>

          <div style="float:left;clear:none;width:150px">
            <button matTooltip="{{ 'common.cerca' | translate }}" mat-button attr.aria-label="{{ 'common.cerca' | translate }}" matTooltipClass="tooltip-style" style="min-width:45px;padding:10px" (click)="sendActiveFilters()">
            <mat-icon color="primary" style="font-size: 24px">search</mat-icon>
          </button>
          <button matTooltip="{{ 'common.reinicia' | translate }}" attr.aria-label="{{ 'common.reinicia' | translate }}" matTooltipClass="tooltip-style" mat-button style="min-width:45px;padding:10px" (click)="resetActiveFilters()">
            <mat-icon color="primary" style="font-size: 24px">autorenew</mat-icon>
          </button>
          </div>
        </div>
        <label *ngSwitchCase="'select'" style="max-width: 33%;display: flex;flex-grow: 1;flex-basis: 0;">
          {{input.description}}
          <mat-select [(ngModel)]="filterModel[input.name]" name="{{input.name}}" ngDefaultControl>
            <mat-option *ngFor="let option of input.options"  value="{{option.value}}">{{option.text}}</mat-option>
          </mat-select>
        </label>
      </div>
    </div>
  </form>
</div>

<div *ngFor="let dataList of dataLists">
  <datalist id="{{dataList.id}}">
    <option
      *ngFor="let option of dataList.options | async"
      value="{{option.value}}">
      {{option.text}}
    </option>
  </datalist>
</div>
